(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../icon", "../_mixins/checkbox"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../icon"), require("../_mixins/checkbox"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.icon, global.checkbox);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _icon, _checkbox) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _icon = _interopRequireDefault(_icon);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        ref: "nx-radio",
        staticClass: "nx-radio",
        class: {
          'os-a-eclipse-click': _vm.parent.direction === 'vertical' && _vm.parent.stackDark === true
        },
        style: !_vm.border ? "border-bottom: none;--color-nx-radio: " + _vm.radioColor : "--color-nx-radio: " + _vm.radioColor,
        on: {
          "click": _vm.onClick
        }
      }, [_c('div', {
        staticClass: "nx-radio-inside",
        class: _vm.radioClass,
        attrs: {
          "tabindex": "-1",
          "role": "radio",
          "aria-checked": _vm.checked,
          "aria-disabled": _vm.isDisabled
        }
      }, [_c('span', {
        ref: "icon",
        staticClass: "nx-radio__icon"
      }, [_c('span', {
        staticClass: "nx-radio__icon-init os-a-eclipse-click",
        class: _vm.iconClass
      })]), _c('span', {
        ref: "label",
        staticClass: "nx-radio__label",
        class: _vm.labelClass
      }, [_vm._t("default")], 2)])]);
    },
    name: 'nx-radio',
    components: (0, _defineProperty2.default)({}, _icon.default.name, _icon.default),
    mixins: [(0, _checkbox.CheckboxMixin)({
      parent: 'nxRadio',
      role: 'radio'
    })],
    data: function data() {
      return {};
    },
    props: {
      border: {
        type: Boolean,
        default: true
      },
      radioColor: {
        type: String,
        default: ''
      }
    },
    computed: {
      currentValue: {
        get: function get() {
          return this.parent ? this.parent.value : this.value;
        },
        set: function set(val) {
          ;
          (this.parent || this).$emit('input', val);
        }
      },
      checked: function checked() {
        return this.currentValue === this.name;
      },
      radioIcon: function radioIcon() {
        return this.checked ? 'circle-select' : 'circle';
      }
    },
    methods: {
      toggle: function toggle() {
        this.animation = true; // this.animation = this.currentValue != this.name

        this.currentValue = this.name;
      }
    }
  };
  _exports.default = _default;
});